
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.688 7.714c-.815-.048-1.515.59-1.563 1.429.048.838.748 1.477 1.563 1.428h3.124c2.605 0 4.688 1.922 4.688 4.286s-2.083 4.286-4.688 4.286L13.5 22H11l-.313-2.857C8.084 19.143 6 17.22 6 14.857h3.125c.048.838.748 1.477 1.563 1.429h3.124c.815.048 1.515-.59 1.563-1.429-.048-.838-.748-1.477-1.563-1.428h-3.124C8.082 13.429 6 11.507 6 9.143c0-2.372 2.083-4.286 4.688-4.286L11 2h2.5l.313 2.857c2.604 0 4.687 1.922 4.687 4.286h-3.125c-.048-.838-.748-1.477-1.563-1.429h-3.124z","fill":"#6b6b6b","fill-rule":"evenodd"}})])
          )
        }
      }
    